import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Reset scroll to the top on every route change. React Router doesn't do this by
// default, so navigating (e.g. Home → /userquiz) otherwise keeps the previous
// page's scroll offset — which hid the top of the Your Quizzes page (the quiz-view
// tabs) until the user scrolled up. Rendered once inside <Router>.
export default function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
        // Safety net: clear any body scroll-lock a modal may have left behind, so pages
        // like the statistics page always scroll after navigating away from a modal.
        document.body.style.overflow = '';
    }, [pathname]);
    return null;
}
